import { FirmaElectronicaService } from './../../../services/firma-electronica/firma-electronica.service';
import { GuiasService } from './../../../services/guias/guias.service';
import { EmpresasService } from 'app/services/empresas/empresas.service';
import { MessagesStatus, MessagesTitles } from './../../../models/messages';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Persona } from '../../../models/Persona';
import { ActivatedRoute } from '@angular/router';
import Swal from "sweetalert2";
import * as moment from 'moment';
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material";
import { LINEA,CONFIG } from 'app/models/NuevoCMAdquirente.model';
import { environment } from 'environments/environment';
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;
@Component({
  selector: 'app-nuevo-cm-adquirente',
  templateUrl: './nuevo-cm-adquirente.component.html',
  styleUrls: ['./nuevo-cm-adquirente.component.scss'],
  providers:[MessagesTitles,MessagesStatus,Persona,{
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },
  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class NuevoCmAdquirenteComponent implements OnInit {
  
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  @Output() cerrarContratoMarcoAdq: EventEmitter<boolean>;
  razSocial : string;
  loading:boolean = false;
  save:boolean = false;
  user:any;
  formularioGenerarContrato : FormGroup;
  formConfig : FormGroup;
  idEmpresa : string;
  Titulo :string;
  
  lineaSoles:any = '';
  lineaDolares:any = '';
  dataEnviar :any={};
  dataEnviarKeynua :any={};
  dataContract : any = [];
  linea : LINEA[] = [];
  config : CONFIG[] = [];
  Fecha = moment();
  
  rProvCombo : any =[];
  rRefBancariaArray : any =[];
  rProvRefBancarias : any =[];
  rProvRefBancariasDolares : any =[];
  tipoServicio :any;

  
  abrirAgregarContacto : boolean;
  idContactoS: string;
  
  selectedItems = [];
  selectedItemsCLI = [];
 
  error : boolean = false;
  textError: string = "";

  constructor(private empresasService : EmpresasService ,  
              private routerActive:ActivatedRoute,
              private datePipe: DatePipe ,
              private msgStatus:MessagesStatus,
              private msgTitulos : MessagesTitles,
              private guiasService : GuiasService,
              private firmaElectronicaService:FirmaElectronicaService,
              ) {           

    this.tipoServicio = this.empresasService.tipoServicio   
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.Titulo = "Nuevo Contrato Marco";
    this.cerrarContratoMarcoAdq = new EventEmitter();

    this.routerActive.params.subscribe( params => {
      this.idEmpresa = params['id']; 
    })
 
   this.formularioGenerarContrato = new FormGroup({
    "idEmpresa":new FormControl(this.idEmpresa,  Validators.required),
    "Tipo_Servicio":new FormControl(this.tipoServicio,  Validators.required),
    "Fecha_Inicio": new FormControl('',  Validators.required),
    "Fecha_Final": new FormControl('',  Validators.required),
    "Pagare": new FormControl('N',  Validators.required),
    "BancoSoles":new FormControl(''),
    "BancoDolar":new FormControl(''),
    "Alta_Usuario":new FormControl(this.user.Usuario,  Validators.required),

    });
     
    this.formConfig = new FormGroup({
        FlagFirmaDesembolso: new FormControl(true , []),
        FlagPagoInteres : new FormControl(false , []),
        FlagTasa : new FormControl(true, []),
        FlagPorcentajeAdelanto : new FormControl(false, []),
        FlagGastosAsociados : new FormControl(false, []),
        TasaMinima : new FormControl('0.0', [Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
        TasaMaxima : new FormControl('0.0', [Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
        PorcentajeAdelantoMinimo : new FormControl('0.0', [Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
        PorcentajeAdelantoMaximo : new FormControl('0.0', [Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
        GastoMinimo : new FormControl('0.0', [Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
        GastoMaximo : new FormControl('0.0', [Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
        Alta_Usuario : new FormControl(this.user.Usuario,  Validators.required),
        Alta_Canal : new FormControl('W', []),
        Alta_Fecha : new FormControl(this.datePipe.transform(this.Fecha,"yyyy-MM-dd"), []),
      }); 
  }

  ngOnInit() {

   this.razSocial = sessionStorage.getItem('razSocial');
    
    this.ListarRepresentantesEmpresa(this.idEmpresa);
    this.ListarReferenciasBancarias(this.idEmpresa);

  }
  representanteIF(event){
    this.selectedItems = event;
  }
  representanteCLI(event){
    this.selectedItemsCLI = event;
  }

  calcularFechaFin(){
    let now = moment(this.formularioGenerarContrato.controls["Fecha_Inicio"].value._d).add(1,'years').subtract(1,'days');
    this.formularioGenerarContrato.controls["Fecha_Final"].setValue(now);
  }

  ListarRepresentantesEmpresa(idEmpresa){
    this.guiasService.setDataRepresentanteCLI([]);
    this.loading = true;
    this.empresasService.obtenerContactosEmpresa(idEmpresa).subscribe(
      res => {       
          this.rProvCombo = res;
            let tipoContacto: any = [];
            let guiaTipo: any;
            this.guiasService.TipoContacto.subscribe(
              response => {
                tipoContacto = response;
                guiaTipo = tipoContacto.find(state => state.Codigo.toLowerCase().indexOf('rl') === 0)
              }
            );          
            this.rProvCombo = this.rProvCombo.filter(
              state => state.Des_Estado.toLowerCase().indexOf('activo') === 0 && state.Tipo_de_Contacto === guiaTipo.idGuia
            );        
            this.guiasService.setDataRepresentanteCLI(this.rProvCombo);
          this.loading = false;
      },(err: HttpErrorResponse)=> {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
            console.error("Error Event");
        } else {
            this.msgStatus.getMessage(err.status);            
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA REPRESENTANTES NO OBTENIDO. "+this.msgStatus.message ,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      }) ;
  }

  ListarReferenciasBancarias(idProvi){
    this.loading = true;
    this.empresasService.obtenerReferenciasBancariasEmpresa(idProvi).subscribe(
      res => {       
          this.rProvRefBancarias = res;
            this.rProvRefBancariasDolares = this.rProvRefBancarias.filter(
            state => state.Moneda == this.Label_id_dolares && state.Estado.toLowerCase().indexOf('activo') === 0 && state.FlgPredeterminado == 1 && state.Tipo_Servicio == this.tipoServicio
          );
          this.rProvRefBancarias = this.rProvRefBancarias.filter(
            state => state.Moneda == this.Label_id_soles && state.Estado.toLowerCase().indexOf('activo') === 0 && state.FlgPredeterminado == 1 && state.Tipo_Servicio == this.tipoServicio
          );
          this.loading = false;
      } , err =>{
          Swal.fire({
            title: "¡Algo salió mal!",
            text:  err.error['error'],
            type: "warning",
            allowOutsideClick: true,
            heightAuto: false
          });        
        this.loading = false;
      }
    )
  }
  
  crearContratoMarco(){
    this.loading = true;
    this.formatearForm();
   this.addDataSelects();
    
    this.dataEnviar.Linea = [];
    
    this.dataEnviar.idEmpresa =  this.formularioGenerarContrato.controls['idEmpresa'].value
    this.dataEnviar.Tipo_Servicio =  this.formularioGenerarContrato.controls['Tipo_Servicio'].value
    this.dataEnviar.Tipo_Proceso =  '142'
    this.dataEnviar.Fecha_Inicio =  this.formularioGenerarContrato.controls['Fecha_Inicio'].value
    this.dataEnviar.Fecha_Final =  this.formularioGenerarContrato.controls['Fecha_Final'].value
    this.dataEnviar.Pagare =  this.formularioGenerarContrato.controls['Pagare'].value
    this.dataEnviar.IF_Representante_Legal_1 =  " "
    this.dataEnviar.PRV_Representante_Legal_1 =  " "
    this.dataEnviar.IF_Representante_Legal_2 =  " "
    this.dataEnviar.PRV_Representante_Legal_2 =  " "
    this.dataEnviar.Correo =  " "
    this.dataEnviar.BancoSoles =  this.formularioGenerarContrato.controls['BancoSoles'].value
    this.dataEnviar.BancoDolar =  this.formularioGenerarContrato.controls['BancoDolar'].value
    this.dataEnviar.Alta_Usuario =  this.formularioGenerarContrato.controls['Alta_Usuario'].value

    /*if (this.dataEnviar.BancoSoles == "" && this.dataEnviar.BancoDolar == "") {
      Swal.fire({
        title: "¡Advertencia!",
        text: "Seleccione banco",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });   
      return
    }*/

    if (this.lineaSoles == '' || this.lineaSoles == null) {
      this.lineaSoles = 0.00
      this.linea.push({Moneda:2,LineaTotal:this.lineaSoles,
        LineaDisponible:this.lineaSoles,
        Alta_Usuario:this.formularioGenerarContrato.controls['Alta_Usuario'].value,
        Alta_Canal:"W",
        Alta_Fecha: this.datePipe.transform(this.Fecha,"yyyy-MM-dd")});
    }else{
      this.linea.push({Moneda:2,LineaTotal:Number(this.lineaSoles).toFixed(2) ,
        LineaDisponible:Number(this.lineaSoles).toFixed(2),
        Alta_Usuario:this.formularioGenerarContrato.controls['Alta_Usuario'].value,
        Alta_Canal:"W",
        Alta_Fecha: this.datePipe.transform(this.Fecha,"yyyy-MM-dd")});
    }
    if (this.lineaDolares == '' || this.lineaDolares == null) {
      this.lineaDolares = 0.00
      this.linea.push({Moneda:3,LineaTotal:this.lineaDolares ,
        LineaDisponible:this.lineaDolares,
        Alta_Usuario:this.formularioGenerarContrato.controls['Alta_Usuario'].value,
        Alta_Canal:"W",
        Alta_Fecha: this.datePipe.transform(this.Fecha,"yyyy-MM-dd")});
    }else{
      this.linea.push({Moneda:3,LineaTotal:Number(this.lineaDolares).toFixed(2) ,
        LineaDisponible:Number(this.lineaDolares).toFixed(2),
        Alta_Usuario:this.formularioGenerarContrato.controls['Alta_Usuario'].value,
        Alta_Canal:"W",
        Alta_Fecha: this.datePipe.transform(this.Fecha,"yyyy-MM-dd")});
    }
        for (const item of this.linea) {
          this.dataEnviar.Linea.push(item);
        }
        
      this.empresasService.guardarContratoMarco(this.dataEnviar)
      .subscribe(res => {
        this.loading = false;
        this.save = true;
        Swal.fire({
          title: 'Registrado con éxito',
          text: '¿Desea enviar contrato digital a keynua.?',
          type: "success",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
          heightAuto: false
        }).then((result) => {
          if (result.value) {
            this.dataContract = res;
            this.dataEnviarKeynua.IDCMarco = this.dataContract.IDCMarco
            this.enviarContratoMarcoElectronico(this.dataEnviarKeynua);
          }else if (
            result.dismiss === Swal.DismissReason.cancel
          ) {
            this.loading = false;
          }
        });

      },(err: HttpErrorResponse)=> {
        this.loading = false;
        this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Contrato marco no creado. "+this.msgStatus.message ,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      })      
  } 

  enviarContratoMarcoElectronico(dataEnviarKeynua){

    this.firmaElectronicaService.enviarContratoMarcoElectronico(dataEnviarKeynua).subscribe(
        res => {       
          this.showNotification('success','top','right','Documento enviado satisfactoriamente para su firma digital.');
        },err => {
          if (err.error.message) {
           this.showNotification('warning','top','right','No se pudo enviar contrato digital a keynua. \n Error: ' + err.error.message);
          }else{
           let error = "";
           error = err.error.error;
           this.showNotification('warning','top','right','No se pudo enviar contrato digital a keynua. \n Error: ' + error);
          }
        
        }
    );
  }

  addDataSelects(){
    this.dataEnviar.Firmantes = [];
    this.dataEnviar.FirmantesIF = [];
    this.dataEnviar.FirmantesAd = [];
    this.selectedItemsCLI.forEach(item => { 
      this.dataEnviar.Firmantes.push(
        {
          'Nombre_Firmante' : item.Nombre_de_Contacto,
          'Correo' : item.Correo,
          'Telefono': item.NroMovil_Laboral,
          'Tipo_Doc_Identificacion':item.Tipo_Documento_Identidad,
          'Tipo_Doc_Identificacion_Dsc':item.Tipo_Documento_Identidad_Dsc,
          'Num_Doc_Identificacion': item.Nro_Documento_Identidad,
          'Tipo_Firmante': item.Rol_del_Contacto,
          'Cargo' : item.Rol_Del_Contacto_Dsc,
          'Raz_Social' : item.Razon_Social,
          'RUC' : item.Num_Doc_Identificacion,
          'Direccion': item.Direccion_Persona,
          'Distrito':item.Distrito,
          'Provincia':item.Provincia,
          'Departamento':item.Departamento
         }
      );
      this.dataEnviar.FirmantesAd.push(
        {
          'Nombre_Firmante' : item.Nombre_de_Contacto,
          'Correo' : item.Correo,
          'Telefono': item.NroMovil_Laboral,
          'Tipo_Doc_Identificacion':item.Tipo_Documento_Identidad,
          'Tipo_Doc_Identificacion_Dsc':item.Tipo_Documento_Identidad_Dsc,
          'Num_Doc_Identificacion': item.Nro_Documento_Identidad,
          'Tipo_Firmante': item.Rol_del_Contacto,
          'Cargo' : item.Rol_Del_Contacto_Dsc,
          'Raz_Social' : item.Razon_Social,
          'RUC' : item.Num_Doc_Identificacion,
          'Direccion': item.Direccion_Persona,
          'Distrito':item.Distrito,
          'Provincia':item.Provincia,
          'Departamento':item.Departamento
         }
      )
    });
    this.selectedItems.forEach(item => { 
      this.dataEnviar.Firmantes.push(item)
      this.dataEnviar.FirmantesIF.push(item)
    });
  }

  formatearForm(){
    let fec_ini =  this.datePipe.transform(this.formularioGenerarContrato.controls["Fecha_Inicio"].value,"yyyy-MM-dd");
    let fec_fin =  this.datePipe.transform(this.formularioGenerarContrato.controls["Fecha_Final"].value,"yyyy-MM-dd");
    this.formularioGenerarContrato.controls["Fecha_Inicio"].setValue(fec_ini);
    this.formularioGenerarContrato.controls["Fecha_Final"].setValue(fec_fin);

    if (this.formConfig.controls['FlagFirmaDesembolso'].value == true ){
      this.formConfig.controls['FlagFirmaDesembolso'].setValue(1)
    }else{
      this.formConfig.controls['FlagFirmaDesembolso'].setValue(0)
    }
    if (this.formConfig.controls['FlagPagoInteres'].value == true ){
      this.formConfig.controls['FlagPagoInteres'].setValue(1)
    }else{
      this.formConfig.controls['FlagPagoInteres'].setValue(0)
    }
    if (this.formConfig.controls['FlagTasa'].value == true ){
      this.formConfig.controls['FlagTasa'].setValue(1);
    }else{
      this.formConfig.controls['FlagTasa'].setValue(0)
    }
    if (this.formConfig.controls['FlagPorcentajeAdelanto'].value == true ){
      this.formConfig.controls['FlagPorcentajeAdelanto'].setValue(1);
    }else{
      this.formConfig.controls['FlagPorcentajeAdelanto'].setValue(0)
    }
    if (this.formConfig.controls['FlagGastosAsociados'].value == true ){
      this.formConfig.controls['FlagGastosAsociados'].setValue(1)
    }else{
      this.formConfig.controls['FlagGastosAsociados'].setValue(0)
    }

    this.config.push({
      Alta_Usuario:this.formularioGenerarContrato.controls['Alta_Usuario'].value,
      Alta_Canal:"W",
      Alta_Fecha: this.datePipe.transform(this.Fecha,"yyyy-MM-dd"),
      FlagFirmaDesembolso:this.formConfig.controls['FlagFirmaDesembolso'].value,
      FlagGastosAsociados:this.formConfig.controls['FlagGastosAsociados'].value ,
      FlagPagoInteres:this.formConfig.controls['FlagPagoInteres'].value,
      FlagPorcentajeAdelanto:this.formConfig.controls['FlagPorcentajeAdelanto'].value,
      FlagTasa:this.formConfig.controls['FlagTasa'].value,
      GastoMaximo:Number(this.formConfig.controls['GastoMaximo'].value/100).toFixed(4),
      GastoMinimo:Number(this.formConfig.controls['GastoMinimo'].value/100).toFixed(4),
      PorcentajeAdelantoMaximo:Number(this.formConfig.controls['PorcentajeAdelantoMaximo'].value/100).toFixed(4),
      PorcentajeAdelantoMinimo:Number(this.formConfig.controls['PorcentajeAdelantoMinimo'].value/100).toFixed(4),
      TasaMaxima:Number(this.formConfig.controls['TasaMaxima'].value/100).toFixed(4),
      TasaMinima:Number(this.formConfig.controls['TasaMinima'].value/100).toFixed(4)
     });

     this.dataEnviar.Config = [];
     for (const item of this.config) {
      this.dataEnviar.Config.push(item);
    }


  }


  SetearRefBancariaSoles(idCuenta){

    
    if(this.rProvRefBancarias.length > 0){
      this.rRefBancariaArray = this.rProvRefBancarias.filter(
        state => state.idCuenta == idCuenta
      );
      let descripcionBanco = 
        ((this.rRefBancariaArray[0].Tipo_de_Cuenta == 90) ? "A":"C")+"|"+
        this.rRefBancariaArray[0].NroCuenta+"|"+
        this.rRefBancariaArray[0].Banco_Dsc+"|"+
        ((this.rRefBancariaArray[0].Moneda == this.Label_id_dolares) ? "D":"S")+"|"+
        this.rRefBancariaArray[0].CCI+"|"+
        this.rRefBancariaArray[0].idCuenta;
      this.formularioGenerarContrato.controls['BancoSoles'].setValue(descripcionBanco);
    }
  }

  SetearRefBancariaDolares(idCuenta){
    if(this.rProvRefBancariasDolares.length > 0){
      this.rRefBancariaArray = this.rProvRefBancariasDolares.filter(
        state => state.idCuenta == idCuenta
      );
      let descripcionBanco = 
      ((this.rRefBancariaArray[0].Tipo_de_Cuenta == 90) ? "A":"C")+"|"+
        this.rRefBancariaArray[0].NroCuenta+"|"+
        this.rRefBancariaArray[0].Banco_Dsc+"|"+
        ((this.rRefBancariaArray[0].Moneda == this.Label_id_dolares) ? "D":"S")+"|"+
        this.rRefBancariaArray[0].CCI+"|"+
        this.rRefBancariaArray[0].idCuenta;
      this.formularioGenerarContrato.controls['BancoDolar'].setValue(descripcionBanco);
    }
  }

  SetearRepIF(idRepresentanteIF){
    this.formularioGenerarContrato.controls['IF_Representante_Legal_1'].setValue(idRepresentanteIF);
  }

  nuevoContacto(){
    this.idContactoS = "";
    this.empresasService.addContactoEmpresa = true;
    this.abrirAgregarContacto = true;
  }
  
  Refresh() {
    this.ngOnInit();
  }

  CerrarPopUp(){
    this.cerrarContratoMarcoAdq.emit();
    this.guiasService.setDataRepresentanteCLI([]);
  }

  CerrarPopUpContacto(click:boolean){
    this.abrirAgregarContacto = false; 
  }

  showNotification(type,from,align,message){

  $.notify({
      icon: "notifications",
      message: message
  },{
      type: type,
      timer: 4000,
      placement: {
          from: from,
          align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
          '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
      '</div>'
  });
  }

}

